import React from 'react';

const HeroComponent = () => {
    return (
        <section>
            <div className="infocolors-hero-block infocolors-hero-type01">
                <div className="stg-row stg-bottom-gap-l stg-m-bottom-gap-l">
                    <div className="stg-col-9 stg-tp-col-8 stg-m-col-12">
                        <h1 className="infocolors-page-title" data-split-appear="fade-up" data-split-unload="fade-up">We Are Capturing the World's Creative Pulse.</h1>
                    </div>
                    <div className="stg-col-3 stg-tp-col-4 stg-m-col-12">
                        <div className="infocolors-hero-social-proof">
                            <div data-stagger-appear="fade-up" data-stagger-delay="100" data-stagger-unload="fade-up">
                                <img src={process.env.PUBLIC_URL + "/img/home/social-proof01.jpg"} alt="Client 01" />
                                <img src={process.env.PUBLIC_URL + "/img/home/social-proof02.jpg"} alt="Client 02" />
                                <img src={process.env.PUBLIC_URL + "/img/home/social-proof03.jpg"} alt="Client 03" />
                                <a href="/contact">10K+</a>
                            </div>
                            <p data-appear="fade-up" data-unload="fade-up" data-delay="200">Inspire & Create</p>
                        </div>
                    </div>
                </div>
                <div className="infocolors-hero-media-wrap infocolors-masked-bottom-right infocolors-masked-block stg-bottom-gap-l" data-appear="zoom-out" data-unload="zoom-out">
                    <div className="infocolors-masked-media infocolors-masked-media infocolors-parallax-media">
                        <img src={process.env.PUBLIC_URL + "/img/home/home01-hero.jpg"} alt="Unleash Your Creativity" />
                    </div>
                    <div className="infocolors-masked-content at-bottom-right">
                        <a href="#page01" className="infocolors-square-button" data-appear="fade-left">
                            <span className="infocolors-icon infocolors-icon-arrow-down"></span>
                        </a>
                    </div>
                </div>
                <div className="stg-row stg-valign-bottom">
                    <div className="stg-col-3 stg-tp-col-3 stg-m-col-6" data-appear="fade-up" data-delay="200" data-unload="fade-up">
                        <div className="infocolors-counter infocolors-small-counter" data-delay="3000">
                            <div className="infocolors-counter-number">30</div>
                            <div className="infocolors-counter-label">Completed Projects</div>
                        </div>
                    </div>
                    <div className="stg-col-3 stg-tp-col-3 stg-m-col-6" data-appear="fade-up" data-delay="300" data-unload="fade-up">
                        <div className="infocolors-counter infocolors-small-counter" data-delay="3000">
                            <div className="infocolors-counter-number" data-suffix="+">10</div>
                            <div className="infocolors-counter-label">Years of Experience</div>
                        </div>
                    </div>
                    <div className="stg-col-6 stg-tp-col-6 stg-m-col-12 stg-m-top-gap" data-appear="fade-up" data-delay="400" data-unload="fade-up">
                        <p className="infocolors-large-text">Unveiling the Art of Media: Event Coverage, Cinematography & Professional Content Creation.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroComponent;
